<template>
    <v-navigation-drawer
        v-model="drawer"
        app
        fixed
        clipped
        :width="isOnMobile ? '100%' : 300"
        :mini-variant.sync="mini"
        mini-variant-width="75"
        style="min-width: 75px;"
      >
      <v-list-item class="px-2">
        <v-btn block text @click.stop="toggleReduceDrawer()" class="d-flex justify-end" data-testid="voicemails-drawer-minimize-btn">
          <v-icon v-if="mini">mdi-chevron-right</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <mailbox-select @load="loadVoicemailsForUsers" class="mx-2" v-if="!mini"/>
      <v-list>
        <v-list-item
          v-for="folder in folders"
          :key="folder.text"
          :to="{ name: 'voicemails', params: { folder: folder.name }}"
          exact
          @click="reloadList()"
          v-show="folder.displayed"
          :class="folder.class"
          data-testid="voicemails-drawer-folder-item"
        >
          <v-list-item-icon>
            <v-icon>{{ folder.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title data-testid="voicemails-drawer-folder-item-name">{{ folder.text }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action style="max-width: 10px !important;" class="ml-4" v-if="folder.name === 'inbox'">
            <v-badge
              :value="sipuaVmNum"
              offset-y="10"
            >
              <span slot="badge"> {{ sipuaVmNum }} </span>
            </v-badge>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <div class="bottom-btn">
        <v-btn block @click="openSettings" :icon="mini" data-testid="voicemails-drawer-settings-btn">
          <v-icon left>mdi-cog</v-icon>
          <span v-if="!mini">Settings</span>
        </v-btn>
      </div>
    </v-navigation-drawer>
  </template>

<script>
import MailboxSelect from '@/components/voicemails/drawer/mailbox_select'
import MixinVoicemailsFolders from '@/mixins/voicemails/folders'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'voicemails-drawer',
  data () {
    return {
      dialog: false,
      mini: false

    }
  },
  pros: ['id'],
  mixins: [
    MixinVoicemailsFolders
  ],
  components: {
    MailboxSelect
  },
  computed: {
    ...mapGetters({
      sipuaVmNum: 'sipuaVmNum',
      filter: 'voicemails/filter',
      drawerState: 'voicemails/drawerState'
    }),
    drawer: {
      get () {
        return this.drawerState
      },
      set (drawerState) {
        this.setDrawerState(drawerState)
      }
    },
    isOnMobile () { return this.$vuetify.breakpoint.mobile }
  },
  mounted () {
    this.selectFolder(this.$route?.params?.folder)
  },
  watch: {
    '$route.params.folder' (newFolder, oldFolder) {
      this.selectFolder(newFolder)
    },
    '$vuetify.breakpoint.mobile': {
      handler () {
        if (this.isOnMobile) {
          this.drawer = false
        } else {
          this.drawer = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setFilter: 'voicemails/setFilter',
      reloadPage: 'voicemails/reloadPage',
      loadVoicemailsForUsers: 'voicemails/loadVoicemailsForUsers',
      setPage: 'voicemails/setPage',
      setDrawerState: 'voicemails/setDrawerState'
    }),
    toggleReduceDrawer () {
      if (this.isOnMobile) {
        this.drawer = !this.drawer
      } else {
        this.mini = !this.mini
      }
    },
    navigateMobile () {
      if (this.isOnMobile) {
        this.drawer = false
      }
    },
    selectFolder (folder) {
      if (!parseInt(folder) && folder !== 'detail' && folder !== 'settings') {
        folder = folder || 'all'
        this.setFilter({ ...this.filter, folder: folder })
      }
    },
    async reloadList () {
      this.navigateMobile()
      await this.setPage(1)
      this.reloadPage()
    },
    openSettings () {
      this.navigateMobile()
      if (this.$route?.params?.folder !== 'settings') {
        this.$router.push({ name: 'voicemails', params: { folder: 'settings' } })
      }
    }
  }
}
</script>

  <style>
  .bottom-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
  </style>
